import { MONTH_ORDER, getExamEventScheduleTitle } from '@exam-center/exam-event-management';
import { type GetMonthlyExamEventOverviewQuery } from '@exam-center/graphql';

import { type MonthlyExamEventListItem } from '../../components';

type OverviewItems = GetMonthlyExamEventOverviewQuery['ecGetMonthlyExamEventOverview']['overview'];

export function mapMonthlyExamEventOverviewToListItems(
  overviewItems: OverviewItems,
  year: number,
): MonthlyExamEventListItem[] {
  return MONTH_ORDER.map((monthAbbr, order) => {
    const overviewItem = overviewItems.find((item) => item.month === order);

    const { events, courses } = overviewItem ?? {};

    return {
      id: monthAbbr,
      examEventCount: events ?? 0,
      examCourseCount: courses ?? 0,
      month: monthAbbr,
      no: order + 1,
      period: getExamEventScheduleTitle(year, monthAbbr),
    };
  });
}
